var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32545 16.1879L7.72773 12.989C8.29503 12.6531 9.00327 12.6656 9.55829 13.0215L11.4137 14.211C12.0548 14.622 12.8884 14.5698 13.4731 14.0819L16.3626 11.6711C17.0215 11.1213 17.9823 11.1323 18.6284 11.697L22.9422 15.4671M23.5 12C23.5 18.0751 18.5751 23 12.5 23C6.42485 23 1.5 18.0751 1.5 12C1.5 5.92485 6.42485 1 12.5 1C18.5751 1 23.5 5.92485 23.5 12ZM10.0522 7.80564C10.0522 8.90327 9.16235 9.79308 8.06468 9.79308C6.96705 9.79308 6.07724 8.90327 6.07724 7.80564C6.07724 6.70801 6.96705 5.8182 8.06468 5.8182C9.16235 5.8182 10.0522 6.70801 10.0522 7.80564Z",
    stroke: "#066D54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.dca11830.svg";
export { ForwardRef as ReactComponent };